import styled from 'styled-components';

const Container = styled.div`
  color: ${({ color }) => color || 'initial'};
  width: 125px;
  margin-left: 15px;
`;

export default Container;
